import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Home, ArrowLeft, Trees, FileText } from "lucide-react";
import Navigation from "../components/layout/Navigation";
import Footer from "../components/layout/Footer";

const NotFoundPage = () => {
  useEffect(() => {
    document.title = "Page non trouvée | Sylva Invest";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'La page que vous recherchez n\'existe pas. Retrouvez nos services de transactions forestières, remembrement et conseil.');
    }
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
      metaRobots.setAttribute('content', 'noindex, follow');
    }
    return () => {
      document.title = "Sylva Invest — Transactions Forestières, Remembrement & Conseil (France)";
      if (metaDescription) {
        metaDescription.setAttribute('content', 'Sylva Invest accompagne propriétaires, héritiers et investisseurs pour recomposer le foncier forestier morcelé.');
      }
      if (metaRobots) {
        metaRobots.setAttribute('content', 'index, follow');
      }
    };
  }, []);

  return (
    <>
      <Navigation />
      <main className="pt-20 min-h-screen bg-cream flex items-center justify-center">
        <div className="max-w-2xl mx-auto px-6 py-24 text-center">
          <p className="text-xs uppercase tracking-[0.2em] text-gold font-sans font-semibold mb-4">
            Erreur 404
          </p>
          <h1 className="font-serif text-4xl md:text-5xl text-forest mb-6" data-testid="404-heading">
            Page non trouvée
          </h1>
          <p className="font-sans text-lg text-gray-600 mb-10 leading-relaxed">
            La page que vous recherchez n'existe pas ou a été déplacée. 
            Retrouvez nos ressources sur le foncier forestier ci-dessous.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Link
              to="/"
              className="btn-primary bg-forest text-white hover:bg-gold hover:text-forest flex items-center gap-2"
              data-testid="404-home-link"
            >
              <Home className="w-4 h-4" />
              Retour à l'accueil
            </Link>
            <Link
              to="/ressources"
              className="btn-primary bg-gold text-forest hover:bg-forest hover:text-white flex items-center gap-2"
              data-testid="404-resources-link"
            >
              <FileText className="w-4 h-4" />
              Nos ressources
            </Link>
          </div>

          <div className="border-t border-gray-200 pt-10">
            <p className="font-sans text-sm text-gray-500 mb-6">Pages suggérées :</p>
            <ul className="flex flex-wrap justify-center gap-4 text-sm">
              <li>
                <Link to="/remembrement-forestier" className="text-forest hover:text-gold transition-colors">
                  Remembrement forestier
                </Link>
              </li>
              <li>
                <Link to="/transactions-forestieres" className="text-forest hover:text-gold transition-colors">
                  Transactions forestières
                </Link>
              </li>
              <li>
                <Link to="/vendre-parcelle-bois" className="text-forest hover:text-gold transition-colors">
                  Vendre une parcelle
                </Link>
              </li>
              <li>
                <Link to="/#contact" className="text-forest hover:text-gold transition-colors">
                  Nous contacter
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default NotFoundPage;
